import './Detail.scss';
import React, { useEffect } from 'react';
import HeaderTitle from '../comm/HeaderTitle';
import { Section } from '../scss/theme';

const Detail = ({ setIsModal, selectedItem }) => {
  useEffect(() => {
    if (!selectedItem) {
      alert('교재를 찾지 못했습니다.');
      setIsModal(false);
    }
  }, [selectedItem, setIsModal]);

  if (!selectedItem) return null; // 선택된 책이 없으면 렌더링 안함

  return (
    <div className="Detail">
      <HeaderTitle 
        onBackClick={() => setIsModal(false)} 
        direction={1} 
        title={selectedItem.title || 'Unknown Title'} 
      />
      <Section className="sec-content">
        <div className="book-detail">
          <img 
            src={selectedItem.image || '/default-book-image.jpg'} 
            alt={selectedItem.bookName || 'Book Image'} 
            className="book-image"
          />

          <div className="book-info">
            <h2>{selectedItem.bookName}</h2>
            <p><strong>종류:</strong> {selectedItem.kind}</p>
            <p><strong>저자:</strong> {selectedItem.author}</p>
            <p><strong>출판사:</strong> {selectedItem.publisher}</p>
            <p><strong>출판일:</strong> {selectedItem.pubdate}</p>
            <p><strong>설명1:</strong></p>
            <p>{selectedItem.description || 'No description available.'}</p>

            {selectedItem.description_kuesb && (
              <>
                <p><strong>설명2:</strong></p>     
                <p>{selectedItem.description_kuesb}</p>
              </>
            )}
          </div>
        </div>
      </Section>
    </div>
  );
};

export default Detail;
